import React, {Component} from 'react'

import ColorList from './colorList/'

export default () => <div><ColorList/></div>



// WEBPACK FOOTER //
// ./src/components/menu.js